module.exports = "/images/link-teams.svg?946fe37bccd445b0505b735ee0835bd0";